import React from 'react';
import StringUtil from '@common/string-util';
import { traceLog, getCodec } from '../../common/api';
import { parseURL } from '@common/utils';
import { isAndroid, isIOS } from "@utils/index";
import './index.less';
const rootConf = require('./deploy.json');

class App extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      deviceUuid: window.localStorage.getItem('_deviceUuid') || '',
      sessionId: StringUtil.randomSessionId(),
      sessionSeq: 1,
      pageName: `https://i.localhome.cn/v/${rootConf.activity_id}`,
      pageContextId: StringUtil.randomSessionId(),
      actionCode: `activity_${rootConf.activity_id}`,
      traceData: {},
      isLoading: true,
      redirectUrl: ''
    };
    this.timer = null;
  }

  componentDidMount () {
    /**
     * 获取当前地址为path,判断path后面是否有参数
     * 例如：https://i.localhome.cn/v/2506301109311/jdksk
     * 1. 解析出 code（jdksk），请求 /codec/get
     * 2. 若返回 data.source 包含 https，则重定向到 source
     * 3. 否则回退重定向到 https://wxaurl.cn/jdksk
     * 例如：https://i.localhome.cn/v/2506301109311
     * 则重定向到 https://minsubao.localhome.cn
     * */
    this.handleRedirect();
  }

  goRedirect = (redirectUrl) => {
    this.setState({
      redirectUrl,
      isLoading: false
    });
    window.location.href = redirectUrl;
  }

  handleRedirect = async () => {
    try {
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const pathname = url.pathname;

      // 解析路径，获取活动ID和可能的额外参数
      // 例如: /v/2506301109311/jdksk → ['v', '2506301109311', 'jdksk']
      const pathParts = pathname.split('/').filter(part => part);
      const hasExtraParams = pathParts.length > 2;

      if (!hasExtraParams) {
        // 没有额外参数，重定向到 minsubao.localhome.cn
        const redirectUrl = 'https://minsubao.localhome.cn';
        console.log('重定向到 minsubao.localhome.cn:', redirectUrl);
        this.goRedirect(redirectUrl);
        return;
      }

      // 有额外参数，解析 code（活动ID后的第一段）
      const code = pathParts[2] || '';
      // 原有兜底地址：i.localhome.cn → wxaurl.cn，保留后续 path
      const fallbackWxaUrl = currentUrl.replace('i.localhome.cn/v/2506301109311', 'wxaurl.cn');

      if (!code) {
        console.log('未解析到 code，回退 wxaurl.cn:', fallbackWxaUrl);
        this.goRedirect(fallbackWxaUrl);
        return;
      }

      try {
        const res = await getCodec({ code });
        const source = (res && res.data && res.data.source) || '';
        if (source && String(source).indexOf('https') !== -1) {
          console.log('codec source 跳转:', source);
          this.goRedirect(source);
          return;
        }
      } catch (apiError) {
        console.error('codec/get 请求失败，回退 wxaurl.cn:', apiError);
      }

      console.log('重定向到 wxaurl.cn:', fallbackWxaUrl);
      this.goRedirect(fallbackWxaUrl);
    } catch (error) {
      console.error('重定向处理失败:', error);
      // 发生错误时，默认重定向到 minsubao.localhome.cn
      this.goRedirect('https://minsubao.localhome.cn');
    }
  }

  render () {
    const { isLoading, redirectUrl } = this.state;
    
    return (
      <div className="index">
        {/* <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          padding: '20px',
          textAlign: 'center'
        }}>
          {isLoading ? (
            <div>
              <div style={{
                width: '40px',
                height: '40px',
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #3498db',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 20px'
              }}></div>
              <p style={{ fontSize: '16px', color: '#333' }}>正在处理重定向...</p>
            </div>
          ) : (
            <div>
              <div style={{
                width: '60px',
                height: '60px',
                background: '#4CAF50',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px'
              }}>
                <span style={{ color: 'white', fontSize: '24px' }}>✓</span>
              </div>
              <p style={{ fontSize: '16px', color: '#333', marginBottom: '10px' }}>
                即将跳转到：
              </p>
              <p style={{ 
                fontSize: '14px', 
                color: '#666', 
                wordBreak: 'break-all',
                maxWidth: '300px',
                margin: '0 auto'
              }}>
                {redirectUrl}
              </p>
            </div>
          )}
        </div>
        
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style> */}
      </div>
    );
  }
}

export default App;
